export const OPEN_SOON_SELECT_NEW_MEMBER_MID_WINDOW = 'OPEN_SOON_SELECT_NEW_MEMBER_MID_WINDOW';
